import React from 'react';
import ReactDOM from 'react-dom/client';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource-variable/outfit';
import { App } from './app/App';
import { ColorModeProvider } from './app/colorMode';
import { ToastProvider } from './components/Toast';
import { HttpError } from './lib/api';
import { AuthProvider } from './lib/auth';

const onError = (e: unknown) => {
  if (e instanceof HttpError && e.code === 'MFA_SETUP_REQUIRED') {
    window.dispatchEvent(new Event('portal:mfa-required'));
  }
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, e) => !(e instanceof HttpError && e.status < 500) && count < 2,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ColorModeProvider>
      <QueryClientProvider client={queryClient}>
        {/* URL updates render as normal updates, not concurrent transitions: under React 18 a
            transition render overlapping a menu's exit animation can drop the menu's "exited"
            update and leave an invisible backdrop over the page. */}
        <BrowserRouter useTransitions={false}>
          <ToastProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ColorModeProvider>
  </React.StrictMode>,
);
